import {Component, OnInit} from '@angular/core';
import {IncidentReportsService} from '../../../services/incident-reports.service';
import {HistoryItem} from '../../directory-item/activity/history-item.class';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'incident-report-history-modal',
    templateUrl: 'incident-report-history-modal.component.html',
    styleUrls: ['incident-report-history-modal.component.scss']
})
export class IncidentReportHistoryModalComponent implements OnInit {
    showModal = false;
    activities: HistoryItem[] = [];

    constructor(
        public incidentReportsService: IncidentReportsService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.loadIncidentReportHistory();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    loadIncidentReportHistory() {
        this.incidentReportsService
            .getIncidentReportHistory(this.incidentReportsService.historyModalIncidentReport.id)
            .subscribe(items => this.activities = items);
    }

    hideModal() {
        this.incidentReportsService.historyModalIncidentReport = null;
        this.urlService.modalClosed.emit();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-history-modal/incident-report-history-modal.component.ts